export enum SelfServe {
  Transaction = 'transaction',
  Inquiry = 'inquiry',
}
